<template>
  <section class="campanhas">
    <form-spinner v-if="loading" />

    <ul v-if="campanhas">
    <li v-for="(item, i) in campanhasFiltradas" :key="item.idNegocieJaCampanha">
        <header class="nomeCampanha">
          <h5>
            <input-control
              v-if="item.isNew"
              v-model="item.nome"
              placeholder="Nome da Campanha"
            />
            <span v-else>{{ item.nome }}</span>
          </h5>

          <div>
            <switch-control
              @change="toggleActiveCampanha(i)"
              v-model:checked="item.ativo"
              labelOff="Inativo"
              labelOn="Ativo"
              labelPos="esq"
            />

            <span>
              <a href="#" @click.prevent="toggleActive(i)">
                <fa
                  :icon="[
                    'far',
                    'arrow-up-right-and-arrow-down-left-from-center',
                  ]"
                  class="icon"
                />
              </a>
            </span>
          </div>
        </header>

        <div>
          <table>
            <thead>
              <tr>
                <th colspan="2">Período</th>
                <th colspan="2">Faixa de Valor (R$)</th>
                <th>Qtd. Dias</th>
                <th>Tipos de Bloqueio</th>
                <th>Formas de Pagamento</th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td class="fullCell">
                  <input-control
                    cssClass="invis text-center"
                    v-model="item.dtInicial"
                    type="date"
                    :readonly="!item.active"
                  />
                </td>
                <td class="fullCell">
                  <span class="arrowTag">
                    <fa :icon="['fas', 'chevrons-right']" />
                  </span>
                  <input-control
                    cssClass="invis text-center"
                    v-model="item.dtFinal"
                    type="date"
                    :readonly="!item.active"
                  />
                </td>

                <td class="fullCell">
                  <input-control
                    cssClass="invis text-center"
                    v-model="item.valorInicial"
                    ismoney
                    :readonly="!item.active"
                  />
                </td>
                <td class="fullCell">
                  <span class="arrowTag">
                    <fa :icon="['fas', 'chevrons-right']" />
                  </span>
                  <input-control
                    cssClass="invis text-center"
                    v-model="item.valorFinal"
                    ismoney
                    :readonly="!item.active"
                  />
                </td>

                <td class="fullCell">
                  <input-control
                    cssClass="invis text-center"
                    v-model="item.quantidadeDiasDebitosVencidos"
                    type="number"
                    :readonly="!item.active"
                  />
                </td>

                <td>
                  <div class="multiple">
                    <span>{{ item.tipoBloqueio.length }}</span>
                    <p v-if="item.tipoBloqueio">
                      {{ createList(item.tipoBloqueio,'descricao') }}
                    </p>
                  </div>
                </td>
                <td>
                  <div class="multiple">
                    <span>{{ item.formasPagamento.length }}</span>
                    <p v-if="item.formasPagamento">
                      {{ createList(item.formasPagamento, 'nome') }}
                    </p>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>

          <template v-if="item.active">
            <div class="sub-content">
              <form-spinner v-if="item.loadingDetails" />
              <div v-else-if="item.details" class="sub-body">
                <div class="tabs-panel">
                  <nav class="tabs-navs">
                    <a
                      href="#"
                      @click.prevent="toggleTab(i, 'bloqueios')"
                      :class="['tabs-nav', { active: item.activeTab === 'bloqueios' }]"
                    >
                      <span>Tipos de Bloqueio</span>
                    </a>
                    <a
                      href="#"
                      @click.prevent="toggleTab(i, 'publicos')"
                      :class="['tabs-nav', 'has-action', { active: item.activeTab === 'publicos' }]"
                    >
                      <span>Públicos</span>
                      <span class="action" @click.stop.prevent="abrirModalNovoPublico(i)">
                        <fa :icon="['far', 'plus']" />
                      </span>
                    </a>
                    <a
                      href="#"
                      @click.prevent="toggleTab(i, 'pagamento')"
                      :class="['tabs-nav', 'has-action', { active: item.activeTab === 'pagamento' }]"
                    >
                      <span>Formas de Pagamento</span>
                      <span class="action" @click.stop.prevent="abrirModalNovoPagamento(i)">
                        <fa :icon="['far', 'plus']" />
                      </span>
                    </a>
                  </nav>

                  <div class="tabs-controller">
                    <bloqueios
                      v-show="item.activeTab === 'bloqueios'"
                      :bloqueios="item.details.tipoBloqueio"
                      @onChange="addToList('tipoBloqueio', i, $event, 'idmotivoBloqueio')"
                      :ref="'bloqueios_' + i"
                    />
                    <publicos
                      v-show="item.activeTab === 'publicos'"
                      :publicos="item.details.publicos"
                      @onChange="addToList('publicos', i, $event, 'idNegocieJaPublico')"
                      :ref="'publicos_' + i"
                    />
                    <pagamento
                      v-show="item.activeTab === 'pagamento'"
                      :formasPagamento="item.details.formasPagamento"
                      @onChange="addToList('formasPagamento', i, $event, 'idNegocieJaFormaPagamento')"
                      :ref="'pagamentos_' + i"
                    />
                  </div>
                </div>

                <footer class="novaCampanha">
                  <button
                    v-if="item.isNew"
                    class="btn btn-secondary"
                    @click.prevent="cancelarNovaCampanha(i)"
                  >
                    Cancelar
                  </button>
                  <button
                    class="btn btn-primary"
                    @click.prevent="salvarCampanha(i)"
                  >
                    Salvar
                  </button>
                </footer>
              </div>
            </div>
          </template>
        </div>
      </li>
    </ul>

    <novo-publico v-if="mostrarModalNovoPublico" @fechar="fecharModalNovoPublico" />
    <novo-pagamento v-if="mostrarModalNovoPagamento" @fechar="fecharModalNovoPagamento" />
  </section>
</template>

<script>
import FormSpinner from '@/components/utilities/FormSpinner.vue'
import NegociaService from '@/services/negocieja.service.js'
import Bloqueios from '@/components/financeiro/negocieja/bloqueios/SelectBloqueios.vue'
import Publicos from '@/components/financeiro/negocieja/publicos/SelectPublicos.vue'
import Pagamento from '@/components/financeiro/negocieja/pagamentos/SelectPagamento.vue'
import NovoPublico from '@/components/financeiro/negocieja/publicos/NovoPublico.vue'
import NovoPagamento from '@/components/financeiro/negocieja/pagamentos/NovoPagamento.vue'

export default {
  name: 'Campanhas',
  components: {
    FormSpinner,
    Bloqueios,
    Publicos,
    Pagamento,
    NovoPublico,
    NovoPagamento
  },
    props: {
    busca: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      campanhas: [],
      loading: false,
      mostrarModalNovoPublico: false,
      mostrarModalNovoPagamento: false,
      modalActive: null
    }
  },
  mounted () { 
    this.getCampanhas() 
  },
  computed: {
  campanhasFiltradas () {
    if (!this.busca.trim()) return this.campanhas

    return this.campanhas.filter(campanha =>
      campanha.nome.toLowerCase().includes(this.busca.toLowerCase())
    )
  }
},
  methods: {
    addToList ( type, i, value, key ) {
      console.log("value:", value)
      this.campanhas[i].selected[type] = value.map( k => k[key])
      this.campanhas[i].selected[type].sort()
    },
    getCampanhas () {
      this.loading = true
      NegociaService.getCampanhas().then(
        res => {
          this.campanhas = res.data.map(p => ({
            ...p,
            tipoBloqueio: p.tipoBloqueio,
            formasPagamento: p.formasPagamento,
            active: false,
            loadingDetails: false,
            activeTab: 'bloqueios',
            details: null,
            selected: {
              tipoBloqueio: [],
              publicos: [],
              formasPagamento: []
            }
          }))

          this.campanhas.map(k => {
            const vf = k.valorFinal.toString()
            const vi = k.valorInicial.toString()
            k.valorInicial = vi.includes('.') ? k.valorInicial : k.valorInicial + '.00'
            k.valorFinal = vf.includes('.') ? k.valorFinal : k.valorFinal + '.00'
            // console.log("k", k)
          })
        }
      ).catch(err => { 
        console.error("Erro ao carregar campanhas:", err);
      }).finally(() => {
        this.loading = false 
      })
    },
    getDetails(id, i) {
      this.campanhas[i].loadingDetails = true
      
      NegociaService.getCampanha(id).then(response => {
        console.log("getCampanha:", response.data)

        this.campanhas[i].details = {
          tipoBloqueio: response.data.tipoBloqueioSelecionados, 
          publicos: response.data.publicos,
          formasPagamento: response.data.formasPagamento
        }
        this.campanhas[i].selected = {
          tipoBloqueio: [],
          publicos: [],
          formasPagamento: []
        }

        console.log("campanhas:", this.campanhas)
      }).catch(err => {
        console.error('Erro ao buscar detalhes da campanha:', err)
      }).finally(() => {
        this.campanhas[i].loadingDetails = false
      });
    },
    novaCampanha () {
      const nova = {
        idNegocieJaCampanha: null,
        isNew: true,
        nome: '',
        ativo: true,
        active: true,
        loadingDetails: false,
        activeTab: 'bloqueios',
        dtInicial: '',
        dtFinal: '',
        valorInicial: '0,00',
        valorFinal: '0,00',
        quantidadeDiasDebitosVencidos: '',
        tipoBloqueio: [],
        formasPagamento: [],
        publicos: [],
        selected: {
          tipoBloqueio: [],
          publicos: [],
          formasPagamento: []
        },
        details: {
          tipoBloqueio: [],
          publicos: [],
          formasPagamento: []
        }
      }
      this.campanhas.unshift(nova)
    },
    cancelarNovaCampanha (idx) {
      this.campanhas.splice(idx, 1)
      this.$emit('campanha-cancelada')
    },
    salvarCampanha (i) {
      const campanha = this.campanhas[i]
      this.loading = true

      const payload = {
        nome: campanha.nome,
        dtInicial: campanha.dtInicial,
        dtFinal: campanha.dtFinal,
        valorInicial: campanha.valorInicial,
        valorFinal: campanha.valorFinal,
        quantidadeDiasDebitosVencidos: parseInt(campanha.quantidadeDiasDebitosVencidos),
        ativo: campanha.ativo ? 1 : 0,
        tipoProduto: campanha.tipoProduto,
        rematricula: campanha.rematricula,
        tiposBloqueio: campanha.selected.tipoBloqueio,
        formasPagamento: campanha.selected.formasPagamento,
        publicos: campanha.selected.publicos
      }

      if (!campanha.isNew) {
        payload.idNegocieJaCampanha = campanha.idNegocieJaCampanha
      }

      console.log('Enviando payload com chaves no plural:', payload)

      const isNova = campanha.isNew;
      const salvar = isNova
        ? NegociaService.createCampanha(payload)
        : NegociaService.updateCampanha(campanha.idNegocieJaCampanha, payload)

      salvar.then(response => {
        const campanhaSalva = response.data
        this.campanhas[i] = {
          ...campanha,
          ...campanhaSalva,
          isNew: false,
          active: false
        }
        this.$emit('campanha-salva')
        this.getCampanhas()
      }).catch(error => {
        console.error('Erro ao salvar CAMPANHA! Resposta do servidor:', error.response)
      }).finally(() => {
        this.loading = false
      })
    },
    toggleActive (idx) {
      const item = this.campanhas[idx]
      item.active = !item.active
      
      if (item.active && !item.details && !item.isNew) {
        console.log("foi...")
        this.getDetails(item.idNegocieJaCampanha, idx)
      }
    },
    toggleTab (idx, tab) { 
      this.campanhas[idx].activeTab = tab 
    },
    toggleActiveCampanha (idx) {
      this.salvarCampanha(idx)
    },
    createList (arr, key) {
      return Array.isArray(arr) ? arr.map(a => a[key]).join(', ') : ''
    },
    abrirModalNovoPagamento (i) { 
      this.mostrarModalNovoPagamento = true 
      this.modalActive = i
    },
    fecharModalNovoPagamento () { 
      this.mostrarModalNovoPagamento = false

      this.$refs['pagamentos_' + this.modalActive][0].getPagamentos()

      this.$nextTick(() => {
        this.modalActive = null
      })
    },
    abrirModalNovoPublico (i) { 
      this.mostrarModalNovoPublico = true 
      this.modalActive = i
    },
    fecharModalNovoPublico () { 
      this.mostrarModalNovoPublico = false

      this.$refs['publicos_' + this.modalActive][0].getPublicos()

      this.$nextTick(() => {
        this.modalActive = null
      })
    }
  }
}
</script>

<style lang="scss" scoped>

  .nomeCampanha {
    display: flex;

    .input-control{
      width: 40rem;
    }
  }

  .novaCampanha {
    display: flex;
    gap: 1rem;
  }

  .campanhas {
    padding-bottom: $mg_large;

    ul {
      padding: $hmg_mid; margin: 0;

      li {
        list-style: none;
        padding: 0; margin: 0 0 $hmg_mid 0;
        border: $border-component;
        border-radius: $border-radius;
        background-color: $color-secondary;

        header {
          display: flex;
          align-items: center; justify-content: space-between;
          width: 100%; padding: $hmg_small $hmg_mid;

          h5, p {
            padding: 0; margin: 0;
          }
          
          >div {
            display: flex;
            align-items: center;
            gap: $mg;
            
            >span {
              display: flex;
              align-items: center;
              gap: $mg_mini;
              font-size: $font-size-large;

              .icon {
                font-size: 16px;
              }
              &:last-child {
                text-align: right;
                margin-left: $hmg_mid;
              }
              
              a {
                color: $color-primary;
              }
            }
          }
        }

        table {
          width: 100%; border-collapse: collapse;
          overflow: hidden;
          table-layout: fixed;

          thead {
            border-top: $border-component;

            tr {
              height: 50px;
              
              th {
                font-size: $font-size-small;
                padding: 0 $hmg_mid;
                text-align: center;

                &:nth-last-child( -n + 2 ) {
                  min-width: 280px; width: 20%; max-width: 360px;
                }
              }
            }
          }
          tbody {
            overflow: hidden;
            border-top: $border-component;

            tr {
              height: 50px;
              overflow: hidden;

              td {
                border: $border-component;
                padding: 0 $hmg_mid;
                position: relative;
                text-align: center;
                z-index: 8;
                
                &:first-child {
                  border-left: none !important;
                }
                &:last-child {
                  border-right: none !important;
                }

                &.over {
                  background-color: $color-debito;
                }
                &.under {
                  background-color: $color-credito;
                }

                &.fullCell {
                  padding: 0;
                }

                .arrowTag {
                  display: flex; flex-direction: column;
                  justify-content: center; align-items: center;
                  position: absolute; top: 50%; left: 0;
                  transform: translate(-50%, -50%);
                  width: 21px; height: 21px;
                  border-radius: 100%; border: $border-component;
                  font-size: 10px;
                  z-index: 12;
                  color: $color-text; background-color: $color-secondary;

                  &.over {
                    color: $color-primary;
                  }

                  &.under {
                    color: $color-success-2;
                  }
                }

                &.arrowCell {
                  >div {
                    display: flex; align-items: center; justify-content: center;
                    gap: $hmg_mini
                  }
                }

                .multiple {
                  display: flex; align-items: center;
                  gap: $mg_mini; overflow: hidden;
                  
                  span {
                    display: block;
                    width: 24px; height: 24px;
                    text-align: center; line-height: 24px;
                    flex-shrink: 0;
                    border: $border-component;
                    border-radius: 100%;
                  }
                  p {
                    margin: 0; padding: 0;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    white-space: nowrap;
                  }
                }
              }

              &.spinner {
                height: auto;

                td {
                  background-color: $color-secondary;
                  padding: 0 !important;
                }
              }
              &.subHeader {
                height: 40px;
                background-color: $color-bg;

                h4 {
                  margin: 0; padding: 0;
                }
              }

              &:last-child {
                td {
                  border-bottom: none !important;

                  &:last-child {
                    border-right: none !important;
                    border-bottom-right-radius: $border-radius;
                  }
                }
              }
            }
          }
        }

        .sub-content {
          width: 100%;
          border-top: $border-component;

          .sub-body {
            padding: $hmg_mid;

            a {
              cursor: pointer;
            }

            footer {
              display: flex;
              align-items: center;
              justify-content: flex-end;
              padding-top: $hmg_mid
            }
          }
        }
      }
    }
  }
</style>